import { Route } from 'vue-router'

import BehaviorConfig from '@/models/app-config/behavior/behavior'
import { InstanceResolver } from '@/util/instanceResolver'

export function extractBrand(to: Route): string | null {
  if (InstanceResolver.isSingle()) {
    return InstanceResolver.getSingleBrand()
  }

  /**
   * TODO:
   * 将来的に、SPAでのブランド名解決もURLパラメータから行われる(/:brand_english_name/hoge)ようにする予定.
   * クエリパラメータからも取得するようになっているが、将来的には to.params 経由に統一する.
   */
  const brandFromParams = typeof to.params.brand_english_name === 'string' ? to.params.brand_english_name : null
  const brandFromQuery = typeof to.query.brand === 'string' ? to.query.brand : null

  return brandFromParams || brandFromQuery
}

export function extractBrandFromUrl(url: string): string | null {
  if (InstanceResolver.isSingle()) {
    return InstanceResolver.getSingleBrand()
  }

  const reg = /^https?:\/\/[^\/]*\/([^\/\?#]*)/
  const match = url.match(reg)

  if (match === null) {
    return null
  }

  return match[1]
}

export function extractGroup(brand: string | null): string {
  const behavior = brand ? BehaviorConfig.createFromBrand(brand) : new BehaviorConfig()

  return behavior.groupId
}
